import * as React from "react";
import { useTranslation } from "react-i18next";
import { ReadOnlyFormGroup } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import EditLinkButton from "./EditLinkButton";
import { STEP_KEY as SERVER_CONFIG_KEY } from "../BackendWizard/ServerConfigStep";
const ServerConfigSection = ({ authenticationBackend }) => {
  const { t } = useTranslation("authentication");
  const {
    title,
    description,
    config: { servers = [], systemUserDn, systemUserPassword, transportSecurity, verifyCertificates }
  } = authenticationBackend;
  const serverUrls = servers.map((server) => `${server.host}:${server.port}`).join(", ");
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: t("server_config.title"),
      headerActions: /* @__PURE__ */ React.createElement(EditLinkButton, { authenticationBackendId: authenticationBackend.id, stepKey: SERVER_CONFIG_KEY })
    },
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("server_config.title_label"), value: title }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("server_config.description_label"), value: description }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("server_config.server_address"), value: serverUrls }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("server_config.system_username"), value: systemUserDn }),
    /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: t("server_config.system_password"),
        value: (systemUserPassword == null ? void 0 : systemUserPassword.isSet) ? "******" : null
      }
    ),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("server_config.transport_security"), value: transportSecurity }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("server_config.verify_certificates"), value: verifyCertificates })
  );
};
export default ServerConfigSection;
